import { ErrorConfigurations } from "../utils/ErrorConfigurations";

const ResponseParser = (response) => {
    try {
        if(response.status === 404 || response.status === 500){
            return { status: response.status, exception_message: ErrorConfigurations.message.callForAssistance}
        }else{
            return response.json().then((value)=>{
                return value
            }).catch((error)=>{
                return { status: 500, exception_message: ErrorConfigurations.message.callForAssistance}
            })
        }
    } catch (error) {
        return { status: 500, exception_message: ErrorConfigurations.message.callForAssistance}
    }
    
}

export default ResponseParser;